import CommonLandingContainer from '../../../../landingComponents/containers/common';
import styles from './aboutFirst.module.scss';
import {
  Heading1,
  SubTitle,
  SmallText,
  Button,
} from '../../../../landingComponents/typography';
import hand from 'src/assets/img/landing/hand.png';
import phoneScreen from 'src/assets/img/landing/phoneScreen.png';
import { ReactComponent as AboutBullits } from 'src/assets/img/landing/aboutBullits.svg';

const FirstBlock = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <div className={styles.header}>
        <Heading1 className={styles.headerText} accent>Как это работает?</Heading1>
        <AboutBullits  className={styles.headerBullits}/>
      </div>
    </CommonLandingContainer>
  );
};

export default FirstBlock;
